import "./style.css";
import TaskList from "./TaskList";

function App() {
  return (
    <main>
      <h1>Task Manager</h1>
      <TaskList />
    </main>
  );
}

export default App;
